// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"652":"9a4b92a2","787":"a3143f5f","851":"deb3caee"}[chunkId] + ".chunk.js";
};